// extracted by mini-css-extract-plugin
export default {"flexToolbar":"ToolbarCases_flexToolbar__Nc2MB"};